import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';


@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [ConfirmationDialogComponent],
    declarations: [ConfirmationDialogComponent],
    providers: [],
})
export class ConfirmationDialogModule { }
